import styled from "styled-components";

export const TimeLeft = styled.span`
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  min-width: 50px;
`